import { AssessmentFormsMultiSelect } from "./AssessmentFormsMultiSelect";
import { EmailLists } from "./EmailLists";
import { HospitalEmails } from "./HospitalEmails";

export const Mod = {
  AssessmentFormsMultiSelect,
  EmailLists,
  HospitalEmails,
};
